export default __webpack_public_path__ + "static/media/Dist.48c69986.jpg";